import {
  createStore,
  // Config
  getAppConfig,
} from '@sttedra_ui/framework';

import appModule from '../modules/app';
import registerModule from '../modules/register';
import textModule from '../modules/text';

const {isProduction} = getAppConfig();

const store = createStore(isProduction);

store.registerModule('app', appModule);
store.registerModule('register', registerModule);
store.registerModule('text', textModule);

export default store;
